// /api/carrier-selection/terminals?terminalCode=null&terminalCode=null&shipmentDate=2025-09-12&scac=ABFS&carrierId=238846&serviceTypeId=8

import { useQuery } from "@tanstack/react-query";

import { terminalResponseSchema } from "~/shared/schemas/terminal-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";
import { formatDateToYYYYMMDD } from "~/shared/utils/string-fns.ts";

// needs 1 terminal code, scac, shipmentdate, carrier id

export const useGetTerminalDetails = (
	originTerminalCode: string | null,
	destinationTerminalCode: string | null,
	shipmentDate: string | Date,
	scac: string,
	carrierId: number,
	serviceTypeId: string | null,
	enabled = true,
) => {
	const terminalCodeParams = [originTerminalCode, destinationTerminalCode]
		.filter((code): code is string => code !== null)
		.map((code) => `terminalCode=${encodeURIComponent(code)}`)
		.join("&");
	const baseParams = [
		terminalCodeParams,
		`shipmentDate=${formatDateToYYYYMMDD(shipmentDate)}`,
		`scac=${encodeURIComponent(scac)}`,
		`carrierId=${encodeURIComponent(String(carrierId))}`,
	];

	if (serviceTypeId) {
		baseParams.push(`serviceTypeId=${encodeURIComponent(serviceTypeId)}`);
	}

	const params = baseParams.join("&");

	const url = `${apiRoutes.GETCARRIERTERMINALINFO}${params}`;
	return useQuery({
		queryKey: [
			"getTerminalDetails",
			originTerminalCode,
			destinationTerminalCode,
			shipmentDate,
			scac,
			carrierId,
			serviceTypeId,
			enabled,
		],
		queryFn: async () => {
			const response = await getAndValidate(url, terminalResponseSchema);
			if (response.success) {
				return response.data;
			}

			throw new Error(
				`Failed to fetch terminal details: ${response.error ?? "Unknown error"}`,
			);
		},
		enabled:
			enabled &&
			Boolean(shipmentDate) &&
			Boolean(scac) &&
			Boolean(carrierId) &&
			Boolean(originTerminalCode || destinationTerminalCode),
	});
};
